import type { CSSObject } from 'styled-components';

/** Centres `ProcessingCard` in the modal or the page; top-aligned once it overflows. */
export const PROCESSING_CENTRE_STYLES = {
	overflowY: 'auto',
	'& > *': { margin: 'auto 0' },
} satisfies CSSObject;
